import { StyledH2, StyledParagraph } from '../../SwapTokens/utils';
import { GreenCheckmarkIcon } from './ListIcons/GreenCheckmarkIcon';
import { GreenGasIcon } from './ListIcons/GreenGasIcon';
import { GreenLightningIcon } from './ListIcons/GreenLightningIcon';

export function NewTradeModeSection() {
  return (
    <div
      className="border border-token-gray-300 border-solid overflow-hidden rounded-lg rounded-b-2xl tablet:pt-15 px-11 tablet:px-15 w-full mx-auto flex justify-center max-w-[1240px] flex-col items-center pb-[52px] tablet:pb-9 mb-20 pt-12"
      style={{
        background:
          'url(/images/swap-tokens/ring-lines.svg) no-repeat right bottom, url(/images/swap-tokens/wave-lines.svg) no-repeat center bottom, var(--token-color-gray-100)',
      }}
    >
      <StyledH2 className="text-center">
        <span className="text-token-gray-700">New trade mode: </span>Matcha Auto
      </StyledH2>
      <StyledParagraph className="text-center">
        Great prices, with more speed and less worry.
      </StyledParagraph>
      <ul className="mt-12 tablet:mt-[18px] tablet:flex tablet:justify-between tablet:px-5 desktop:px-[62px] tablet:w-full">
        <li className="gap-4 mb-12 flex flex-col items-center text-token-gray-800 leading-6 text-center">
          <GreenLightningIcon />
          Faster trade confirmation
        </li>
        <li className="gap-4 mb-12 flex flex-col items-center text-token-gray-800 leading-6 text-center mt-[52px]">
          <GreenCheckmarkIcon />
          Reduce failed trades by 85%
        </li>
        <li className="gap-4 mb-12 flex flex-col items-center text-token-gray-800 leading-6 text-center">
          <GreenGasIcon />
          Matcha handles the gas
        </li>
      </ul>
    </div>
  );
}
